import { render, staticRenderFns } from "./CategoryShow.vue?vue&type=template&id=f92d62a6&"
import script from "./CategoryShow.vue?vue&type=script&lang=js&"
export * from "./CategoryShow.vue?vue&type=script&lang=js&"
import style0 from "./CategoryShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports